import { PAYMENT_METHODS } from './methods-payment.enum';
import { PaymentListValues } from '../interfaces/services/get-payments-list-service.interface';

export const PAYMENT_FILE_REQUIRED_MESSAGE =
  'Para generar la preliquidación, todos los métodos de pago (excepto Redondeo) deben tener un documento adjunto.';

export const isRoundingPaymentMethod = (code: unknown): boolean =>
  Number(code) === PAYMENT_METHODS.ROUNDING;

export const hasPaymentAttachedFile = (archivo: unknown): boolean =>
  Boolean(
    archivo &&
      archivo !== '0' &&
      archivo !== 'false' &&
      archivo !== '' &&
      archivo !== undefined
  );

export const getPendingPaymentsWithoutFile = (
  paymentsToLoad: Array<{
    newPaymentMethod?: unknown;
    basePaymentMethodData?: { archivo?: unknown };
  }>
) =>
  paymentsToLoad.filter(
    (payment) =>
      !isRoundingPaymentMethod(payment.newPaymentMethod) &&
      !hasPaymentAttachedFile(payment.basePaymentMethodData?.archivo)
  );

export const getSavedPaymentsWithoutFile = (paymentsList: PaymentListValues[]) =>
  paymentsList.filter(
    (payment) =>
      !isRoundingPaymentMethod(payment.codigoFormaDePago) &&
      !hasPaymentAttachedFile(payment.archivo)
  );

export const hasPaymentsMissingRequiredFile = (
  paymentsToLoad: Array<{
    newPaymentMethod?: unknown;
    basePaymentMethodData?: { archivo?: unknown };
  }>,
  paymentsList: PaymentListValues[] = []
) =>
  getPendingPaymentsWithoutFile(paymentsToLoad).length > 0 ||
  getSavedPaymentsWithoutFile(paymentsList).length > 0;
